export function escapeHtml(input: string): string {
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Inline SVG icon referencing the sprite defined in index.html. */
export function icon(name: string): string {
  return `<svg class="ic" aria-hidden="true"><use href="#i-${name}" /></svg>`;
}

export function setHtml(el: HTMLElement, html: string): void {
  el.innerHTML = html;
}

let toastTimer: ReturnType<typeof setTimeout> | undefined;

export function showToast(message: string, isError = false): void {
  const toast = document.getElementById('toast');
  const msg = document.getElementById('toast-msg');
  if (!toast || !msg) return;
  msg.textContent = message;
  toast.classList.toggle('err', isError);
  toast.classList.add('show');
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('show'), 1900);
}

export async function copyText(text: string): Promise<void> {
  try {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        showToast('コピーしました');
        return;
      } catch {
        // Fall through to the legacy path; some embedded browsers expose the
        // Clipboard API but reject writes despite a user click.
      }
    }
    copyTextWithTextarea(text);
    showToast('コピーしました');
  } catch {
    showToast('コピーに失敗しました', true);
  }
}

function copyTextWithTextarea(text: string): void {
  const ta = document.createElement('textarea');
  const active = document.activeElement instanceof HTMLElement ? document.activeElement : undefined;
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.top = '-1000px';
  ta.style.left = '-1000px';
  ta.style.width = '1px';
  ta.style.height = '1px';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  ta.setSelectionRange(0, ta.value.length);
  const copied = document.execCommand('copy');
  document.body.removeChild(ta);
  active?.focus();
  if (!copied) throw new Error('copy command failed');
}

/** Trigger a browser download without navigating away (server sets Content-Disposition). */
export function triggerDownload(url: string): void {
  const a = document.createElement('a');
  a.href = url;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
